import { Provider } from "@angular/core";
import { FilterViewTypeEnum, type FilterRegistration } from "@filter/filter.types";
import * as Filters from "./filters";
import { FILTER_REGISTRY } from "@filter/filter.tokens";

function provideFilter(registration: FilterRegistration): Provider[] {
    return [
        registration.service,
        {
            provide: FILTER_REGISTRY,
            multi: true,
            useValue: registration,
        },
    ];
}

export const FILTER_PROVIDERS = [
    ...provideFilter({
        service: Filters.CurrentlyResponsibleFilterService,
        applications: ["Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary, FilterViewTypeEnum.Normal],
    }),
    ...provideFilter({
        service: Filters.AssigneesFilterService,
        applications: ["iFirmTax", "Taxprep"],
        viewTypes: [FilterViewTypeEnum.Summary, FilterViewTypeEnum.Normal],
    }),
    ...provideFilter({
        service: Filters.IFirmStepFilterService,
        applications: ["iFirmTax", "Taxprep"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.JobStepFilterService,
        applications: ["Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.ReturnStatusService,
        applications: ["iFirmTax", "Taxprep"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.CategoryFilterService,
        applications: ["iFirmTax", "Taxprep"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.DeliveryMethodFilterService,
        applications: ["iFirmTax", "Taxprep"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.ContactGroup1FilterService,
        applications: ["iFirmTax", "Taxprep", "Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.ContactGroup2FilterService,
        applications: ["iFirmTax", "Taxprep", "Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.JobTypeFilterService,
        applications: ["Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.JobStatusFilterService,
        applications: ["Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.JobGroup1FilterService,
        applications: ["Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.JobGroup2FilterService,
        applications: ["Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.ContactPartnerFilterService,
        applications: ["Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.ContactManagerFilterService,
        applications: ["Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.JobPartnerFilterService,
        applications: ["Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.JobManagerFilterService,
        applications: ["Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.JobOwnerFilterService,
        applications: ["Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
    ...provideFilter({
        service: Filters.JobPriorityFilterService,
        applications: ["Jobs&Billing"],
        viewTypes: [FilterViewTypeEnum.Summary],
    }),
];
